import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {
    ActionNotificationComponent,
    AlertComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent
} from './content/crud';
import {
    ScrollTopComponent,
    SplashScreenComponent,
    UserProfileComponent
} from './layout';
import {NoticeComponent} from './content/general/notice/notice.component';
import {PortletModule} from './content/general/portlet/portlet.module';
import {ErrorComponent} from './content/general/error/error.component';
import {TranslateModule} from '@ngx-translate/core';
import {SelectRelatedUsersComponent} from './select-related-users/select-related-users.component';
import {AddUserToProjectDialogComponent} from './add-user-to-project/add-user-to-project.dialog.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {AddOrModifyUserToConversationDialogComponent} from './add-or-modify-user-to-conversation/add-or-modify-user-to-conversation.dialog.component';
import {FileAnnotationsDialogComponent} from './file-annotations/file-annotations.dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FbxAnnotationsDialogComponent} from './fbx-annotations/fbx-annotations.dialog.component';
import {AddScheduleToProjectDialogComponent} from './add-schedule-to-project/add-schedule-to-project.dialog.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {CropDialogComponent} from './crop-dialog/crop.dialog.component';
import {ImageCropperModule} from 'ngx-image-cropper';
import {FabricModule} from '../../core/fabric-wrapper/fabric.module';
import {SelectAvatarDialogComponent} from './select-avatar/select-avatar.dialog.component';
import {DeleteProjectDialogComponent} from './delete-project-dialog/delete-project.dialog.component';
import {ChatGroupEditDialogComponent} from './chat-group-edit/chat-group-edit.dialog.component';
import { FileLibraryDialogComponent } from './file-library/file-library.dialog.component';
import {A11yModule} from '@angular/cdk/a11y';
import {NgxFileDropModule} from 'ngx-file-drop';
import {MatToolbarModule} from '@angular/material/toolbar';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {MainMenuDialogComponent} from './main-menu/main-menu.dialog.component';
import {MoviePopupDialogComponent} from './movie-popup/movie-popup.dialog.component';
import {CreateZoomMeetingDialogComponent} from './create-zoom-meeting/create-zoom-meeting.dialog.component';
import {StartZoomMeetingDialogComponent} from './start-zoom-meeting/start-zoom-meeting.dialog.component';
import {ZoomAlreadyOpenedDialogComponent} from './zoom-already-opened/zoom-already-opened.dialog.component';
import {FileLibraryImageDialogComponent} from './file-library-image/file-library-image.dialog.component';
import {WatchersEditDialogComponent} from './watchers-edit/watchers-edit.dialog.component';
import {OkDialogComponent} from './ok-dialog/ok.dialog.component';
import {RestoreProjectDialogComponent} from './restore-project-dialog/restore-project.dialog.component';
import {ProjectCardComponent} from './project-card/project-card.component';
import {ChatBalloonComponent} from './chat-balloon/chat-balloon.component';
import {LinkyModule} from 'ngx-linky';
import {UserGroupsEditDialogComponent} from './user-groups-edit/user-groups-edit.dialog.component';
import {CreateUserGroupDialogComponent} from './create-user-group/create-user-group.dialog.component';
import {
    UsersInUserGroupEditDialogComponent
} from './users-in-user-group-edit/users-in-user-group-edit.dialog.component';
import {AsyncImageComponent} from "./async-image/async-image.component";
import { UserViewerComponent } from './user-viewer/user-viewer.component';
import { UsersListComponent } from './users-list/users-list.component';
import { EmojiPanelComponent } from './emoji-panel/emoji-panel.component';
import { ChatDividerComponent } from './chat-divider/chat-divider.component';
import { ProjectNotFoundDialogComponent } from './project-not-found/project-not-found.dialog.component';
import { ConversationNotFoundDialogComponent } from './conversation-not-found/conversation-not-found.dialog.component';

@NgModule({
    declarations: [
        ScrollTopComponent,
        NoticeComponent,
        ActionNotificationComponent,
        DeleteEntityDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertComponent,
        ScrollTopComponent,
        SplashScreenComponent,
        UserProfileComponent,
        ErrorComponent,
        SelectRelatedUsersComponent,
        AddUserToProjectDialogComponent,
        AddScheduleToProjectDialogComponent,
        AddOrModifyUserToConversationDialogComponent,
        DeleteProjectDialogComponent,
        RestoreProjectDialogComponent,
        ChatGroupEditDialogComponent,
        FileAnnotationsDialogComponent,
        FbxAnnotationsDialogComponent,
        CropDialogComponent,
        SelectAvatarDialogComponent,
        FileLibraryDialogComponent,
        FileLibraryImageDialogComponent,
        MainMenuDialogComponent,
        MoviePopupDialogComponent,
        CreateZoomMeetingDialogComponent,
        StartZoomMeetingDialogComponent,
        ZoomAlreadyOpenedDialogComponent,
        WatchersEditDialogComponent,
        ProjectCardComponent,
        ChatBalloonComponent,
        OkDialogComponent,
        UserGroupsEditDialogComponent,
        CreateUserGroupDialogComponent,
        UsersInUserGroupEditDialogComponent,
        AsyncImageComponent,
        UserViewerComponent,
        UsersListComponent,
        EmojiPanelComponent,
        ChatDividerComponent,
        ProjectNotFoundDialogComponent,
        ConversationNotFoundDialogComponent,
    ],
    entryComponents: [
        AddUserToProjectDialogComponent,
        AddScheduleToProjectDialogComponent,
        AddOrModifyUserToConversationDialogComponent,
        DeleteProjectDialogComponent,
        RestoreProjectDialogComponent,
        ChatGroupEditDialogComponent,
        FileAnnotationsDialogComponent,
        FbxAnnotationsDialogComponent,
        CropDialogComponent,
        SelectAvatarDialogComponent,
        FileLibraryDialogComponent,
        FileLibraryImageDialogComponent,
        MainMenuDialogComponent,
        MoviePopupDialogComponent,
        CreateZoomMeetingDialogComponent,
        StartZoomMeetingDialogComponent,
        ZoomAlreadyOpenedDialogComponent,
        OkDialogComponent,
        UserGroupsEditDialogComponent,
        CreateUserGroupDialogComponent,
        UsersInUserGroupEditDialogComponent,
        UserViewerComponent,
        UsersListComponent,
        EmojiPanelComponent,
        ChatDividerComponent,
        ProjectNotFoundDialogComponent,
        ConversationNotFoundDialogComponent,
    ],
    exports: [
        PortletModule,
        ScrollTopComponent,
        NoticeComponent,
        ActionNotificationComponent,
        DeleteEntityDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertComponent,
        ScrollTopComponent,
        SplashScreenComponent,
        UserProfileComponent,
        ErrorComponent,
        SelectRelatedUsersComponent,
        AddUserToProjectDialogComponent,
        AddScheduleToProjectDialogComponent,
        AddOrModifyUserToConversationDialogComponent,
        DeleteProjectDialogComponent,
        RestoreProjectDialogComponent,
        ChatGroupEditDialogComponent,
        CreateZoomMeetingDialogComponent,
        StartZoomMeetingDialogComponent,
        ZoomAlreadyOpenedDialogComponent,
        ProjectCardComponent,
        ChatBalloonComponent,
        OkDialogComponent,
        UserGroupsEditDialogComponent,
        CreateUserGroupDialogComponent,
        UsersInUserGroupEditDialogComponent,
        AsyncImageComponent,
        UserViewerComponent,
        UsersListComponent,
        EmojiPanelComponent,
        ChatDividerComponent,
        ProjectNotFoundDialogComponent,
        ConversationNotFoundDialogComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        PortletModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatSelectModule,
        MatInputModule,
        MatTableModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatIconModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatCardModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatTooltipModule,
        MatDialogModule,
        DragDropModule,
        NgbDropdownModule,
        NgbTooltipModule,
        NgSelectModule,
        TranslateModule.forChild(),
        ImageCropperModule,
        FabricModule,
        A11yModule,
        NgxFileDropModule,
        MatToolbarModule,
        LinkyModule,
        NgScrollbarModule,
    ]
})
export class PartialsModule {
}
